export const bordaFilterFields = [
  {
    name: "nome",
    label: "Nome",
    placeholder: "Buscar por nome...",
    type: "text" as const,
  },
];
